module.exports = __webpack_public_path__ + "img/gme-vs-retail-trading-volume-30d-avg.4acf5dbd.jpg";